import { useCallback, useState } from "react";
import { ThemeType } from "../theme";
import darkTheme from "../theme/dark-theme";
import lightTheme from "../theme/light-theme";
import SimpleStorage from "../../utils/SimpleStorage";

const useThemeType = (defaultThemeType: ThemeType) => {
  const storedThemeType = SimpleStorage.getOrCreate<ThemeType>("THEME", defaultThemeType);

  const getTheme = useCallback((themeType: ThemeType) => {
    return themeType === ThemeType.DARK ? darkTheme : lightTheme;
  }, []);

  const [themeType, setThemeType] = useState<ThemeType>(storedThemeType.get());

  const onChangeTheme = useCallback(
    (themeType: ThemeType) => {
      storedThemeType.set(themeType);
      setThemeType(themeType);
    },
    [storedThemeType]
  );

  return {
    setThemeType: (themeType: ThemeType) => onChangeTheme(themeType),
    theme: {
      ...getTheme(themeType),
      secondaryTheme: getTheme(themeType === ThemeType.DARK ? ThemeType.LIGHT : ThemeType.DARK),
    },
  };
};

export default useThemeType;
